import { render, staticRenderFns } from "./MainPostsByCat.vue?vue&type=template&id=77232e17&scoped=true&"
import script from "./MainPostsByCat.vue?vue&type=script&lang=js&"
export * from "./MainPostsByCat.vue?vue&type=script&lang=js&"
import style0 from "./MainPostsByCat.vue?vue&type=style&index=0&id=77232e17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77232e17",
  null
  
)

export default component.exports